import { useFeatures } from '@/components/providers/site/FeatureProvider'
import { useFirebase } from '@/components/providers/site/FirebaseProvider'

export const useIsMainLayout = () => {
  const { user } = useFirebase()
  const { devLoggedOut } = useFeatures()
  return user && !user?.isAnonymous && !devLoggedOut
}
